import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import './ToolCard.css'

const ToolCard = ({
  icon: Icon,
  title,
  description,
  path,
  className = '',
  ...props
}) => {
  const classes = [
    'tool-card',
    className
  ].filter(Boolean).join(' ')

  return (
    <Link
      to={path}
      className={classes}
      {...props}
    >
      <div className="tool-card-icon">
        <Icon size={25} />
      </div>
      <div className="tool-card-content">
        <h3 className="tool-card-title">{title}</h3>
        <p className="tool-card-description">{description}</p>
      </div>
      <div className="tool-card-arrow">
        <ChevronRight size={16} />
      </div>
    </Link>
  )
}

export default ToolCard
